import { Link } from "react-router-dom";
import {
  beautify,
  createColumn,
  formatCurrency,
  formatDate,
} from "../../utils/helpers";
import { PaymentStatusTag } from "../../components/common/registerUtils";

export const useInvoices = () => {
  const tableColumns = () => [
    ...[
      "generated_on",
      "invoice_for",
      "invoice_number",
      "amount",
      "status",
    ].map((item) => createColumn(item)),
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        invoice_for: beautify(item.type),
        amount: formatCurrency(item?.amount),
        status: (
          <div className="flex gap-2">
            <PaymentStatusTag status={item?.payment_status} />
            <Link
              className="link-with-icon"
              to={`/register/prns?invoice=${item?.id}`}
            >
              PRNS
            </Link>
          </div>
        ),
        generated_on: formatDate(item.created_at),
      };
      return row;
    }),
  ];

  const viewData = (item: any) => {
    return {
      reference_number: item?.reference_number,
      description: item?.description,
      amount: item?.amount,
      entry_type: item?.entry_type,
      entry_period: item?.entry_period,
      debit_account: item?.debit_account,
      credit_account: item?.credit_account,
      member_account: item?.member_account,
      due_date: formatDate(item?.due_date),
      next_date: formatDate(item?.next_date),
      created_at: formatDate(item?.created_at),
    };
  };

  return { tableColumns, tableData, viewData };
};
